import { api } from "./api";

export async function getAllLotteries() {
  const payload = [{ $match: { "extra.active": true } }] as any;

  const { data } = await api.post(`database/lottery/aggregate`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

export async function getParticipantes(id: string) {
    const payload = [
        {
            "$match": {
                "lottery": id
            }
        },
        {
            "$facet": {
                "p1": [
                    {
                        "$lookup": {
                            "from": "player",
                            "localField": "player",
                            "foreignField": "_id",
                            "as": "p"
                        }
                    },
                    {
                        "$unwind": "$p"
                    },
                    {
                        "$addFields": {
                            "type": "player"
                        }
                    }
                ],
                "p2": [
                    {
                        "$lookup": {
                            "from": "team",
                            "localField": "player",
                            "foreignField": "_id",
                            "as": "p"
                        }
                    },
                    {
                        "$unwind": "$p"
                    },
                    {
                        "$addFields": {
                            "type": "team"
                        }
                    }
                ]
            }
        },
        {
            "$project": {
                "all": {
                    "$concatArrays": [
                        "$p1",
                        "$p2"
                    ]
                }
            }
        },
        {
            "$unwind": "$all"
        },
        {
            "$replaceRoot": {
                "newRoot": "$all"
            }
        },
        {
            "$project": {
                "player": 1,
                "type": 1,
                "created": 1,
                "lottery": 1,
                "name": "$p.name",
                "image": "$p.image.small.url",
                "extra": "$p.extra"
            }
        },
        {
            "$group": {
                "_id": "$player",
                "total": { "$sum": 1 },
                "name": { "$first": "$name" },
                "image": { "$first": "$image" },
                "extra": { "$first": "$extra" }
            }
        },
        {
            "$sort": {
                "name": 1
            }
        }
    ] as any;

    const { data } = await api.post(`database/lottery_ticket/aggregate`, payload, { headers: { Range: "items=0-5000", }, });
    if (!Array.isArray(data)) {
        return [];
    } else {
        return data;
    }
}


export async function getRewardItem() {
    const payload = [{$match:{}}] as any;

    const headers = {
        Range: "items=0-1000"
    }
  
    const { data } = await api.post("/database/catalog_item/aggregate", payload, { headers });
    return data;
}


export async function getWinners(id: string) {
  const payload = [
        {
        "$match": {
            "type": 5,
            "item": id
        }
    },
    {
        "$facet": {
            "p1": [
                {
                    "$lookup": {
                        "from": "player",
                        "localField": "player",
                        "foreignField": "_id",
                        "as": "p"
                    }
                },
                {
                    "$unwind": "$p"
                },
                {
                    "$addFields": {
                        "isType": "player"
                    }
                }
            ],
            "p2": [
                {
                    "$lookup": {
                        "from": "team",
                        "localField": "player",
                        "foreignField": "_id",
                        "as": "p"
                    }
                },
                {
                    "$unwind": "$p"
                },
                {
                    "$addFields": {
                        "isType": "team"
                    }
                }
            ]
        }
    },    
    {
        "$project": {
            "all": {
                "$concatArrays": [
                    "$p1",
                    "$p2"
                ]
            }
        }
    },
    {
        "$unwind": "$all"
    },    
    {
        "$replaceRoot": {
            "newRoot": "$all"
        }
    },
    {
        "$lookup": {
            "from": "lottery",
            "localField": "item",
            "foreignField": "_id",
            "as": "l"
        }
    },
    {
        "$unwind": "$l"
    },
    {
        "$project": {
            "player": 1,
            "type": 1,
            "isType": 1,
            "time": 1,
            "item": 1,
            "name": "$p.name",
            "image": "$p.image.small.url",
            "lottery": "$l._id",
            "lottery_ticket": "$extra.ticket",
            "lottery_title": "$l.title",
            "extra": {
                "avatar": "$p.extra.avatar",
                "avatar_type": "$p.extra.avatar_type"
            }
        }
    },
    {
        "$sort": {
            "name": 1
        }
    }
  ] as any;

  const { data } = await api.post(`database/achievement/aggregate`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

export async function getMyNumbers(idLoterry: string | undefined, userId: string | undefined) {  
    const payload = [
        { "$match": { "lottery": idLoterry,  "player": userId} },
        {
            "$lookup": {
                "from": "player",
                "localField": "player",
                "foreignField": "_id",
                "as": "p"
            }
        },
        {
            "$unwind": "$p"
        }
    ] as any;

    const { data } = await api.post(`database/lottery_ticket/aggregate`, payload);
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
}